import React from 'react'
import xml2js from 'xml2js'

// Sanitiza o conteúdo XML
function sanitizeXmlString(xml) {
  if (typeof xml !== 'string') return xml
  if (!xml.includes('&')) return xml

  if (!(xml.includes('<') && xml.includes('>'))) return xml

  return xml.replace(/&(?!([a-zA-Z_][a-zA-Z0-9_]*|#\d+);)/g, '&amp;')
}

function parseXmlToJson(content) {
  return new Promise((resolve, reject) => {
    const sanitized = sanitizeXmlString(content)

    xml2js.parseString(sanitized, (error, result) => {
      if (error) {
        reject(error)
      } else {
        resolve(result)
      }
    })
  })
}

function ImportXmlFiles({ onSuccess, onError, label = 'Importar' }) {
  // Vars
  const inputFileRef = React.createRef()

  // Events
  const onInputFileChange = async evt => {
    try {
      const fileList = evt.target.files
      if (fileList.length === 0) throw new Error('Nenhum arquivo foi selecionado')
      if (!allFilesAreXml(fileList)) throw new Error('Somente arquivos XML são permitidos')

      const json = await getFilesContents(fileList)
      onSuccess(json)
    } catch (e) {
      onError(e)
    }
  }
  const onBtnImportarClick = () => {
    inputFileRef.current.click()
  }

  // Helper
  const allFilesAreXml = fileList => {
    let allXml = true
    for (const file of fileList) {
      allXml = allXml ? file.type === 'text/xml' : false
    }
    return allXml
  }

  const getFilesContents = fileList => {
    return new Promise((resolve, reject) => {
      const filesContent = []

      for (const file of fileList) {
        filesContent.push(getFileContent(file))
      }

      Promise.all(filesContent)
        .then(contents => Promise.all(contents.map(parseXmlToJson)))
        .then(jsonArray => resolve(jsonArray))
        .catch(error => reject(error))
    })
  }

  const getFileContent = file => {
    return new Promise((resolve, reject) => {
      try {
        const reader = new FileReader()
        reader.addEventListener('load', () => {
          resolve(reader.result)
        })
        reader.readAsText(file)
      } catch (e) {
        reject(e)
      }
    })
  }

  // Render
  return (
    <div>
      <input
        type="file"
        accept="text/xml"
        multiple
        onChange={onInputFileChange}
        ref={inputFileRef}
        style={{ display: 'none' }}
      />
      <button className="btnImportar" onClick={onBtnImportarClick}>
        {label}
      </button>
    </div>
  )
}

export default ImportXmlFiles
